import { phaserUtil } from '../engine/phaserUtil-sidecar'
import { l } from '../lib/imports'
import { scene } from '../main/scene-sidecar'
import { ITileDataShip } from '../tiles/tilesDataShip'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { ITileSelector } from '../tiles/tileSelector'
import { tileSelector } from '../tiles/tileSelector-sidecar'
import { cursors } from './cursors-sidecar'

export const createTileSelectors = (tilesData: ITileDataShip[]) => {
  let tileSelectors: ITileSelector[] = []

  let x = 0
  let y = 0
  let s = 40
  l.forEach(tilesData, (c) => {
    let obj = tileSelector.create(c, x * s + 50, y * s + 50)
    tileSelectors.push(obj)
    // console.log(c.name)
    x++
    if (x > 3) {
      x = 0
      y++
    }
    phaserUtil.setInteractive(obj.image)
    obj.image.setInteractive()
    obj.image.on('pointerdown', () => {
      let s = scene.getContext()
      cursors.setToTile(s.cursor, c)
    })
  })
  return tileSelectors
}

let lists: ITileSelector[][] = []
let _mode: TileSelectorMode = 'none'
export type TileSelectorMode =
  | 'none'
  // | 'walls'
  | 'floors'
  | 'objects'
  | 'doors'
  | 'shadows'
  | 'ui'
  | 'test'
  | 'draft'
  | 'structures'
  // new
  | 'deconstruct-hull'
  | 'construct-hull'
  | 'build'
  | 'mine'
  | 'stats'
  | 'cancel'
  | 'o2'
  | 'travel'
  | 'new-game'
  | 'debug-spawn'

export const create = () => {
  let floors = createTileSelectors(tilesDataShip.getFloors())
  let structures = createTileSelectors(tilesDataShip.getStructures())
  // let walls = createTileSelectors(tilesData.getWalls())
  let objects = createTileSelectors(tilesDataShip.getObjects())
  let doors = createTileSelectors(tilesDataShip.getDoors())
  let shadows = createTileSelectors(tilesDataShip.getShadows())
  let ui = createTileSelectors(tilesDataShip.getUi())
  lists = [floors, structures, objects, doors, shadows, ui]
  setMode('structures')

  // dialogs.create(5, 10)
}

export const setMode = (mode: TileSelectorMode) => {
  _mode = mode
  l.forEach(lists, (c) => {
    l.forEach(c, (d) => {
      d.image.visible = false
    })
  })

  let map: { [k: string]: ITileSelector[] } = {
    floors: lists[0],
    structures: lists[1],
    objects: lists[2],
    doors: lists[3],
    shadows: lists[4],
    ui: lists[5],
  }

  let visibleList: ITileSelector[] = map[mode as string] || []
  l.forEach(visibleList, (c) => {
    c.image.visible = true
  })
}

export const update = () => {
  // TODO: if active
}
